import React, { memo, useMemo } from "react";

import { Provider as ReduxProvider } from "react-redux";

import { PlatformContext } from "../interfaces/platform.interface";
import { NetworkContext } from "../interfaces/network.interface";
import { ToastsContext } from "../interfaces/toasts.interface";
import ConfigProvider from "../interfaces/config.interface";
import { setupStore } from "../businessLogic/entities";
import { TranslationsContext } from "../interfaces/translations.interface";
import { PKCEContext } from "../interfaces/pkce.interface";

import BackgroundActions from "./backgroundActions";

import type { LibraryProps } from "./library.types";

function Provider({
  platform,
  network,
  toasts,
  store: passedStore,
  preloadedState,
  config,
  translations,
  pkce,
  children,
}: React.PropsWithChildren<LibraryProps>) {
  const store = useMemo(() => {
    return passedStore || setupStore(preloadedState);
  }, [passedStore, preloadedState]);

  return (
    <ConfigProvider config={config}>
      <PlatformContext.Provider value={platform}>
        <NetworkContext.Provider value={network}>
          <ToastsContext.Provider value={toasts}>
            <ReduxProvider store={store}>
              <TranslationsContext.Provider value={translations}>
                <PKCEContext value={pkce}>
                  <BackgroundActions />
                  {children}
                </PKCEContext>
              </TranslationsContext.Provider>
            </ReduxProvider>
          </ToastsContext.Provider>
        </NetworkContext.Provider>
      </PlatformContext.Provider>
    </ConfigProvider>
  );
}

export default memo(Provider);
